import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import BranchesTable from "./BranchesTable";
import "./Superadmin.css";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import withReactContent from "sweetalert2-react-content";
import { useAdminStore, useAppStore } from "../../stores";
import Select from 'react-select'
import Appstore from "../../stores/Appstore";
import BranchAdminsTable from "./BranchAdminsTable";
import { useImmer } from "use-immer";
import { MdDelete } from 'react-icons/md';
import { BiEdit } from 'react-icons/bi';
import DeleteModal from "./DeleteModal";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
//toast
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

//sweetalert
const MySwal = withReactContent(Swal);
//select react
const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' }
]
const loadAdmins = async ({ branchId, setState }, cb) => {
  try {
    const res = await fetch(`/api/super-admin/branches/${branchId}`);
    if (res.status !== 200) {
      const message = (await res.json()).message;
      throw Error(message);
    }
    const branch = (await res.json()).branch;
    setState(branch);
    cb && cb();
  } catch (error) {
    console.log(error);
    toast.error(error.message, toastOptions);
    cb && cb(error);
  }
}
const AddAdmin = () => {
  const branchId = useParams().id;
  const branchFormRef = useRef();
  const branchName=useRef();
  const branchCode=useRef();
  const hodRef = useRef()
  const hodEmailRef = useRef()
  const addAllAdmins = useAdminStore(state => state.addAllAdmins);
  const addAdmin = useAdminStore(state => state.addAdmin);
  const admins = useAdminStore(state => state.admins);
  const branch = useAdminStore(state => state.branch);
  const setBranch = useAdminStore(state => state.setBranch);
  const showLoading = useAppStore(state => state.showLoading);
  const hideLoading = useAppStore(state => state.hideLoading);
  const loading = useAppStore(state => state.loading);
  const duration = branch ? (branch.degree ? branch.degree.duration : 0) : 0;
  const [years, setYears] = useImmer([]);
  const deleteRef = useRef();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleBranch = async (e) => {
    e.preventDefault();
    try {
      const firstName = e.target.firstName.value, email = e.target.email.value, yearValues = years.map(yr => yr.value);
      const res = await fetch(`/api/super-admin/admins`, {
        method: "post",
        body: JSON.stringify({ firstName, email, years: yearValues, branch: branch._id }),
        headers: {
          'Content-Type': "application/json"
        }
      });
      const { user, message } = await res.json();
      if (res.status !== 200) {
        throw Error(message);
      }
      addAdmin(user);
      MySwal.fire("Added successfully");
    } catch (error) {
      toast.error(error.message, toastOptions);
    }
  }
  useEffect(() => {
    showLoading();
    loadAdmins({ branchId, setState: addAllAdmins }, () => hideLoading());
  }, [branchId])
  if (loading) {
    showLoading();
  }

  const handleEditBranch = async (e) =>{
    e.preventDefault();
    e.target.diabled=true;
    try {
      const res = await fetch(`/api/super-admin/branches/${branchId}`, {
        method: "put",
        body: JSON.stringify({name:branchName.current.value,code:branchCode.current.value}),
        headers: {
          'Content-Type': "application/json"
        }
      });
      const { message, branch } = await res.json();
      if (res.status !== 200) {
        throw Error(message);
      }
      setShow(false);
      setBranch(branch);
      toast.success("Edited successfully",toastOptions);

      e.target.disabled=false;

    } catch (error) {
      console.log(error);
      toast.error(error.message, toastOptions);
      e.target.disabled=false;
      // setShow(false);
    }
  }

  return (
    <>
      {/* <ToastContainer /> */}
      <DeleteModal open={openDeleteModal} ref={deleteRef} onClose={() => setOpenDeleteModal(false)} mode="branch" />
      <form className=" p-4 m-0" style={{ width: "99%" }} ref={branchFormRef} onSubmit={handleBranch}>
        {/* <h1 className="mainHeading">Welcome!</h1> */}

        <div className="d-flex" style={{ justifyContent: "space-between" }}>

          <h3 className="mainHeading ">Add admins to '{branch.name}'</h3>
          <div className="d-flex">
            <BiEdit className="fontSizeBtn" style={{ color: "#0e2d4c" }} onClick={handleShow} />
            <MdDelete className="ms-2 fontSizeBtn" style={{ color: "red" }} onClick={(e) => { deleteRef.current = { _id: branchId, degreeId: branch.degree._id }; setOpenDeleteModal(true); e.preventDefault(); }} />
          </div>
        </div>
        <h5 className="mainHeading subheading mb-4">
          Add admins within branch
        </h5>

        <div className="row" id="addDegree">
          <div className="form-group col-md-4">
            <label for="Degree" className="addDlabel">
              Hod Name
            </label>
            <input
              type="text"
              className="form-control addD"
              placeholder="Enter HOD name"
              name="firstName"
            />
          </div>

          <div className="form-group col-md-4">
            <label for="years" className="addDlabel">
              HOD Email
            </label>
            <input
              type="email"
              className="form-control addD"
              placeholder="HOD Email"
              name="email"
            />
          </div>
          <div className="form-group col-md-4">
            <label for="semesters" className="addDlabel">
              Assigned Years
            </label>
            <Select value={years} onChange={(selected) => setYears(selected)} options={[...Array(duration || 0)].map((value, index) => ({ value: index + 1, label: index + 1 }))} isMulti name="years" />
          </div>
        </div>
        <div
          style={{ display: "flex", width: "100%", justifyContent: "center" }}
        >
          <button className="addDegreebtn col-md-4 mt-4 mb-3" type="submit">
            Add Admin
          </button>
        </div>
        <h3 className="mainHeading m-0 ">Admins you've added</h3>
      </form>
      <div className="row m-0 p-0" style={{ width: "100%", overflowX: "auto" }}>
        <BranchAdminsTable />
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Branch</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div class="mb-3">
              <label for="exampleInputEmail1" class="form-label">Branch name</label>
              <input type="text" ref={branchName} class="form-control" id="branchName" placeholder="Enter branch name" defaultValue={branch.name}></input>
              <div id="branchName" class="form-text">Eg: Computer science engineering</div>
            </div>
            <div class="mb-3">
              <label for="exampleInputPassword1" class="form-label">Branch code</label>
              <input type="text" class="form-control" ref={branchCode} id="branchCode" placeholder="Enter Branch code" style={{textTransform: "uppercase"}} defaultValue={branch.code}></input>
              <div id="branchCode" class="form-text">Eg: CSE</div>
            </div>

          </form>
        </Modal.Body>
        <Modal.Footer>

          <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
            <Button className="saveBtn" onClick={handleEditBranch}>
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddAdmin;
